// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchInput__container-f9299e {
  height: 40px;
  display: flex;
  box-sizing: border-box;
  border-radius: 100px;
  background-color: var(--base-20);
  padding: 4px;
  align-items: center;
  border: 1px solid transparent;
}

.SearchInput__container-f9299e:focus-within {
  border-color: var(--brand-secondary-20);
}

.SearchInput__label-e3f205 {
  display: flex;
  align-items: center;
  flex: 1;
  cursor: text;
  padding-inline-start: 12px;
}

.SearchInput__input-cd3d85 {
  width: 100%;
  flex-grow: 1;
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  color: var(--base-110);
}

.SearchInput__input-cd3d85::placeholder {
  color: var(--base-70);
}

.SearchInput__search-icon-b7e563 {
  width: 16px;
  height: 16px;
  fill: var(--color-icon-hover);
  margin-inline-end: 8px;
  vertical-align: middle;
}

.SearchInput__cross-container-e1face {
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  text-align: center;
  border-radius: 50%;
  margin-inline-start: 4px;
  color: var(--base-60);
}

.SearchInput__cross-container-e1face:hover {
  background-color: var(--base-30);
  color: var(--base-80);
}

.SearchInput__cross-container-e1face:focus-visible {
  background-color: var(--base-30);
  color: var(--base-80);
}

.SearchInput__cross-container-e1face:active {
  background-color: var(--base-40);
  color: var(--base-80);
}

.SearchInput__cross-icon-c12647 {
  width: 16px;
  height: 16px;
  fill: currentColor;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui-kit/src/SearchInput/SearchInput.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,gCAAA;EACA,YAAA;EACA,mBAAA;EACA,6BAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,OAAA;EACA,YAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF;;AAEA;EACE,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,sBAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;AACF;;AAEA;EACE,gCAAA;EACA,qBAAA;AACF;;AAEA;EACE,gCAAA;EACA,qBAAA;AACF;;AAEA;EACE,gCAAA;EACA,qBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  height: 40px;\n  display: flex;\n  box-sizing: border-box;\n  border-radius: 100px;\n  background-color: var(--base-20);\n  padding: 4px;\n  align-items: center;\n  border: 1px solid transparent;\n}\n\n.container:focus-within {\n  border-color: var(--brand-secondary-20);\n}\n\n.label {\n  display: flex;\n  align-items: center;\n  flex: 1;\n  cursor: text;\n  padding-inline-start: 12px;\n}\n\n.input {\n  width: 100%;\n  flex-grow: 1;\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  color: var(--base-110);\n}\n\n.input::placeholder {\n  color: var(--base-70);\n}\n\n.search-icon {\n  width: 16px;\n  height: 16px;\n  fill: var(--color-icon-hover);\n  margin-inline-end: 8px;\n  vertical-align: middle;\n}\n\n.cross-container {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  text-align: center;\n  border-radius: 50%;\n  margin-inline-start: 4px;\n  color: var(--base-60);\n}\n\n.cross-container:hover {\n  background-color: var(--base-30);\n  color: var(--base-80);\n}\n\n.cross-container:focus-visible {\n  background-color: var(--base-30);\n  color: var(--base-80);\n}\n\n.cross-container:active {\n  background-color: var(--base-40);\n  color: var(--base-80);\n}\n\n.cross-icon {\n  width: 16px;\n  height: 16px;\n  fill: currentColor;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchInput__container-f9299e`,
	"label": `SearchInput__label-e3f205`,
	"input": `SearchInput__input-cd3d85`,
	"search-icon": `SearchInput__search-icon-b7e563`,
	"searchIcon": `SearchInput__search-icon-b7e563`,
	"cross-container": `SearchInput__cross-container-e1face`,
	"crossContainer": `SearchInput__cross-container-e1face`,
	"cross-icon": `SearchInput__cross-icon-c12647`,
	"crossIcon": `SearchInput__cross-icon-c12647`
};
module.exports = ___CSS_LOADER_EXPORT___;
